
var swiper = new Swiper(".mySwiper", {
  allowTouchMove: false,
  slidesPerView: 1,
  speed:1200,
  autoplay: {
    duration:2000,
    pauseOnMouseEnter:false,
  },
  loop:true,
  loopPreventsSlide: true,
  loopAdditionalSlides:0,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".page_box div .flex_box",
    clickable:true
  },
  on:{
    init:function(){
      this.change_size = function(){
        if($(window).width() <= 768){
          this.item_width = 120;
          this.instance_span = 162 - this.item_width*2;
          this.init_left = ($(window).width() / 2 - this.item_width / 2);
          var resize_left = this.init_left;
          this.instance = (this.realIndex == 0 ? this.init_left : resize_left -= this.realIndex * (this.item_width + 42));
          $('.page_box>div').css({'margin-left':this.instance+'px'})
        }else{
          $('.page_box>div').attr("style",'')
        }
        $.each($('.swiper-slide'),function(i,v){
          $(v).attr("style",'')
        });
        var max_height = $(window).width() > 768 ? this.$el[0].clientHeight : this.$el[0].clientHeight + 40;
        $.each($('.swiper-slide'),function(i,v){
          $(v).css({height:max_height})
        })
      }
      this.change_size();
    },
    slideNextTransitionStart:function(){
      var instance_span = this.init_left;
      if($(window).width() <= 768){
        if(this.realIndex !== 0){
          instance_span -= this.realIndex * (this.item_width + 42);
        }else{
          instance_span = this.init_left
        }
        $('.page_box>div').animate({'margin-left':instance_span+'px'},1000)
      }
    },
    slidePrevTransitionStart:function(){
      var instance_span = this.init_left
      if($(window).width() <= 768){
        if(this.realIndex !== 0){
          instance_span -= this.realIndex * (this.item_width + 42);
        }
        $('.page_box>div').animate({'margin-left':instance_span+'px'},1000)
      }
    },
  }
});
// 6.6.2之前的版本需要通过代码实现轮播图的暂停
swiper.el.onmouseover = function(){
  swiper.autoplay.stop();
}
swiper.el.onmouseout = function(){
  swiper.autoplay.start();
}
$(window).resize(function(){
  swiper.change_size();
})
function throttle(fn,speed){
  var timer = null;
  return function(){
    var that = this;
    var arg = arguments;
    if(!timer){
     timer = setTimeout(function(){fn.apply(that,arg);timer = null;},speed)
    }
  }
};
$('.choose_box .first img').hover(function(){
    $('.choose_box .item').eq($(this).attr('data-index')).addClass('active').siblings().removeClass('active')
});
//gotop
(function(){
  $('body').append('<img class="gotop" src="https://www.apeaksoft.com/images/top.png" alt="top">');
  $(window).scroll(function(){
      if($(document).scrollTop()>=400){
          $('.gotop').show();
          $('.gotop').click(function(){
              $("body,html").scrollTop(0);
          })
      }else{$('.gotop').hide();};
  });
})();
(function($){$.fn.extend({device_confirm:function(){var userAgentInfo = navigator.userAgent;var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];var flag = true;for (var v = 0; v < Agents.length; v++) {if (userAgentInfo.indexOf(Agents[v]) > 0) {flag = false;break;}}return flag;}})})(jQuery);(function($){$.fn.extend({system_confirm:function(){var userAgentInfo = navigator.userAgent;if(userAgentInfo.indexOf("Win")>-1){return "win"}else if(userAgentInfo.indexOf("Mac")>-1){return "mac"}}})})(jQuery);if(window.innerWidth>956){$(".tab_index").mouseenter(function(){$("#submenu_container").addClass("active"); $(".submenu").eq($(this).index(".tab_index")).addClass("active").siblings(".submenu").removeClass("active");});$("#submenu_container").mouseleave(function(){$("#submenu_container").removeClass("active");$(".submenu").removeClass("active");});};function system_confirm(){var userAgentInfo = navigator.userAgent;if(userAgentInfo.indexOf("Win")>-1){return "win"}else if(userAgentInfo.indexOf("Mac")>-1){return "mac"}};function device_confirm(){var userAgentInfo = navigator.userAgent;var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];var flag = true;for (var v = 0; v < Agents.length; v++) {if (userAgentInfo.indexOf(Agents[v]) > 0) {flag = false;break;}}return flag;};
(function () {
  var isMac,device_com;
  if(system_confirm()=="mac"){isMac=true}
  else if(system_confirm()=="win"){isMac=false}
  if(device_confirm()==true){device_com=true}
  else if(device_confirm()==false){device_com=false}
  if (isMac) {
      $('.mac_btn_box').css({"display":"flex"});
      $('.mac_btn').css({"display":"block"});
      $('.mac_btn_inline').css({"display":"inline-block"});
      $('.win_btn_box').css({"display":"none"});
      $('.win_btn').css({"display":"none"});
      $('.win_btn_inline').css({"display":"none"});
      $('.mobile_btn').css({"display":"none"});
      $('.banner .free_sup_ver_mac').css({"display":"block"});
      $('.banner .free_sup_ver_win').css({"display":"none"});
  } else if (!isMac && device_com == true) {
      $('.win_btn_box').css({"display":"flex"});
      $('.win_btn').css({"display":"block"});
      $('.mac_btn_box').css({"display":"none"});
      $('.mac_btn_inline').css({"display":"none"});
      $('.mac_btn').css({"display":"none"});
      $('.mobile_btn').css({"display":"none"});
      $('.win_btn_inline').css({"display":"inline-block"});
      $('.banner .free_sup_ver_mac').css({"display":"none"});
      $('.banner .free_sup_ver_win').css({"display":"block"});
    
  } else if (device_com == false) {
      $('.pc_btn').css({"display":"none"});
      $('.mobile_btn').show();
      $('.win_btn_inline').css({"display":"inline-block"});
      $('.mac_btn_inline').css({"display":"none"});
      $('.mac_btn_box').css({"display":"none"});
  };
})();



